import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  TenantTestimonialsSettings,
  TenantTestimonialItem,
} from '../../../shared/services/tenant.service';

@Component({
  selector: 'black-testimonials-section',
  templateUrl: './testimonials-section.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class TestimonialsSectionComponent {
  @Input() testimonials?: TenantTestimonialsSettings;
  @Input() theme: 'modern' | 'warm' | 'bold' = 'modern';

  get title(): string {
    return this.testimonials?.title || 'Proven Student Success & Results';
  }

  get items(): TenantTestimonialItem[] {
    if (this.testimonials?.items && this.testimonials.items.length > 0) {
      return this.testimonials.items;
    }
    return [
      {
        name: 'Kasun Perera',
        achievement: 'A Grade - 2024 A/L',
        quote:
          'The paper discussions and weekly theory drills transformed my understanding. The live class explanations were crystal clear and the recordings helped me revise anytime.',
      },
      {
        name: 'Hiruni Silva',
        achievement: 'District 3rd Rank',
        quote:
          'Clear explanations, comprehensive monthly revision packs, and instant doubt clarification. Joining this academy was the turning point in my exam prep.',
      },
      {
        name: 'Dulitha Fernando',
        achievement: 'A Grade - O/L Mathematics',
        quote:
          'Concepts that seemed impossible in school were made intuitive and easy. I went from a C grade in term tests to an A in the final exam!',
      },
    ];
  }
}
